export default [
    {
      path: '/main/positionsandoffset',
      meta: {
        tag: 'positions_offset',
        name: 'Posicionamento e Offset',
        breadcrumb: 'Posicionamento e Offset'
      },
      component: () => import(/* webpackChunkName: "positions_offset" */ '@/views/main/settings/parameters/positionsandoffset/Index.vue'),
      children: [
        {
          path: '',
          name: 'listpositionsandoffset',
          meta: {
            tag: 'positions_offset',
            name: 'Posicionamento e Offset',
            menu: 'settings'
          },
          component: () => import(/* webpackChunkName: "positions_offset" */ '@/views/main/settings/parameters/positionsandoffset/List.vue'),
        }
      ]
    }
]